import client from './client';

export default (function MatchService() {
  let service;

  if (!service) {
    service = client.service('matches');
  }

  return service;
}());
